module.exports = __webpack_public_path__ + "linkedin.png?ab157f6b2ac064711550b26e5ee64de7";